import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule} from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMomentDateModule, MomentDateModule } from '@angular/material-moment-adapter';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        MatButtonModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatMenuModule,
        MatTabsModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatDialogModule,
        ScrollingModule,
        MatProgressSpinnerModule,
        MatSliderModule,
        MatDatepickerModule,
        MatTooltipModule,
        MatMomentDateModule,
        MomentDateModule,
        MatRadioModule,
        MatChipsModule,
        MatBadgeModule,
        MatProgressBarModule
    ],
    exports: [
        MatInputModule,
        MatButtonModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatMenuModule,
        MatTabsModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatDialogModule,
        ScrollingModule,
        MatProgressSpinnerModule,
        MatSliderModule,
        MatDatepickerModule,
        MatTooltipModule,
        MatMomentDateModule,
        MatRadioModule,
        MatChipsModule,
        MatBadgeModule,
        MatProgressBarModule
    ]
})
export class MaterialComponentsModule {}
